<mat-card class="slidecontent">

  <div class="holder">
    <div class="left" [class.active]="showPdfInMobile">
      <div class="header">       

        <button (click)="closeDetail(false)" color="warn" mat-flat-button class="closeAiDetail">        
          <mat-icon>arrow_back_ios</mat-icon> Back
        </button>


         <div class="zoomAndFieldView">
           <mat-slide-toggle color="primary" [checked]="true" [disabled]="isRendering" (change)="showDocs($event)"></mat-slide-toggle>
           {{TitleDocs}}
         </div>

        <div class="actions">

          <!-- <div class="boxholder">
           <mat-slide-toggle color="primary" [checked]="true" [disabled]="isRendering" (change)="showDocs($event)"></mat-slide-toggle>
           {{TitleDocs}}
         </div> -->

        </div> 

        <div class="actions">
         
          
         <!-- <div class="boxholder" *ngIf="showPdfViewer==false"> -->
         <div class="boxholder" *ngIf="showPdfViewer==false">
           <mat-slide-toggle color="primary" [checked]="true" [disabled]="isRendering" (change)="showPDFboxes($event)"></mat-slide-toggle>
            {{TitleForBox}}
         </div>
          
         <div class="d-flex">
           <button matTooltip="Add Documents" mat-stroked-button color="primary" (click)="openPanelMergePDF(mergePDFs)">
            <mat-icon>add</mat-icon> Docs
          </button>
         </div>

          <button mat-icon-button matTooltip="View Document" color="warn" (click)="openDocumentViewer(docViewer)">
            <mat-icon>picture_as_pdf</mat-icon>
          </button> 

         
        </div>

        <!-- <div class="page" *ngIf="showPdfViewer==false">  -->
        <div class="page" *ngIf="showPdfViewer==false">
          Go To Page
          <input type="text" (ngModelChange)="ChangePage($event)" [(ngModel)]="CurrentPage"
            (keypress)="numberOnly($event)">
          / {{totalNumberPages}}        

        </div>

      </div>

      <div class="doc-viewer" *ngIf="showPdfViewer==true">
        <ngx-doc-viewer
            *ngIf="documentType == 'pdf' || documentType == '.pdf'"
            [url]="documentPath"
            viewer="url"
            width="100%"
            height="100%">
        </ngx-doc-viewer>
      </div>

 <div [ngStyle]="{ display: showPdfViewer ? 'none' : 'block' }"> 
      <div class="thumbChart">
        <div class="thumbs">        
          <div  #pdfThumbnailContainer>
          </div>
        </div>
        <div class="chart" #pdfscroll>       
           <div #pdfViewerContainer style="width: 100%; overflow-y: scroll;">
          </div> 
        </div> 
      </div>
  </div> 

    </div>
    <div class="right">
      <div class="tabs">
        <ul>
         <ng-container *ngFor="let nav of navbar; let i = index">
            <li [ngClass]="{'active': nav == currentNavigation}" (click)="navigation(nav)">
              {{nav}}
              <mat-icon *ngIf="nav == 'AI Data' && isOCR==true" class="processed">check_circle</mat-icon>
              <mat-icon *ngIf="nav == 'Key Value' && VectorDocumentID!=''" class="processed">check_circle</mat-icon>
              <mat-icon *ngIf="nav == 'QUESTIONS' && showAIQuestionTickMark==true" class="processed">check_circle</mat-icon>
              <mat-icon *ngIf="nav == 'QUESTIONS' && showAIQuestionLoader=='1'">
               <mat-spinner diameter="20">
               </mat-spinner>
               </mat-icon> 
             
            </li>
          </ng-container>
        </ul>
      </div>


      <div class="newCodingScreen chooseSystemFeild" *ngIf="currentNavigation != 'AI Chat'" >

        <div class="filters">
          <div class="core" *ngIf="currentNavigation == 'AI Data' || currentNavigation == 'QUESTIONS'">

            <div class="coreChange" *ngIf="!toggleChange3c">
              <div class="selectedCore">                
                
                <div class="nameInfo">
                  <h3 matTooltipClass="tooltips" matTooltip="{{name}}"  >{{name}}</h3>
                <p matTooltipClass="tooltips" matTooltip="{{email}}" >{{email}}   </p>   
                </div>  
                <button mat-icon-button (click)="open3cRecordInNewTab()"> 
                  <mat-icon matTooltip="Open in new tab">open_in_new</mat-icon>
                </button> 

              </div>            

              <div class="allaction">

                <button button mat-icon-button (click)="viewRecord()">
                  <mat-icon [matTooltip]="getTooltipTextView()">remove_red_eye                    
                  </mat-icon>
                  <!-- View Record -->
                 </button>  
  
                <button button mat-icon-button *ngIf="ShowPointClickCare==true" (click)="SendtoPendingPatientPCC()" [disabled]="!showPCC" matTooltip="Send to PointClickCare">
                  <mat-icon><img  style="height: 22px;margin-top: -10px;"
                    class="payCheckIcon" src="../../../../assets/icons/pccfavicon-32x32.png"/></mat-icon>
                    <!-- Send to PointClickCare -->
                 </button>
  
                 <button button mat-icon-button (click)="pushMergedDocumentsTo3C()">
                  <mat-icon matTooltip="Push Document">backup                    
                  </mat-icon>
                  <!-- Push Document -->
                </button>  

                <button button mat-icon-button (click)="ChangeCore()">
                  <mat-icon matTooltip="Change Record">edit                    
                  </mat-icon>                    
                </button>  

                <button button mat-icon-button (click)="updateRecord()">
                  <mat-icon [matTooltip]="getTooltipTextUpdate()">update                    
                  </mat-icon>                
                 </button>  

              </div>
            </div>

            <ng-container *ngIf="toggleChange3c">
              <select class="form-select" [(ngModel)]="typeForAddCategory" (change)="selectCCC($event)">
                <option value="1">{{CoreShowName}}</option>
                <option value="2">{{ContactShowName}}</option>
                <option value="3">{{CompanyShowName}}</option>
              </select>

              <div class="coreAutoCompelete" *ngIf="ShowAttchedToCore || ShowAttchedToContact || ShowAttchedToCompany">
                <ng-container *ngIf="ShowAttchedToCore">
                  <input type="text" placeholder="Connect {{CoreShowName}}" [formControl]="stateCtrl"
                    (input)="searchCore($event.target.value)" [matAutocomplete]="auto">
                  <mat-autocomplete #auto="matAutocomplete">
                    <ng-container *ngFor="let core of attachedToCoreList">
                      <mat-option [value]="core.name" (click)="attchedToCoreSelected(core)">
                        {{core.name}}                       
                      </mat-option>

                    </ng-container>

                  </mat-autocomplete>
                </ng-container>

                <ng-container *ngIf="ShowAttchedToContact">
                  <input type="text" placeholder="Connect {{ContactShowName}}" [formControl]="stateCtrl"
                    (input)="searchContacts($event.target.value)" [matAutocomplete]="auto">
                  <mat-autocomplete #auto="matAutocomplete">
                    <ng-container *ngFor="let contact of attachedToContactList">
                      <mat-option [value]="contact.name" (click)="attchedToContactSelected(contact)">
                        {{contact.name}}
                        
                      </mat-option>
                    </ng-container>

                  </mat-autocomplete>
                </ng-container>

                <ng-container *ngIf="ShowAttchedToCompany">
                  <input type="text" placeholder="Connect {{CompanyShowName}}" [formControl]="stateCtrl"
                    (input)="searchCompany($event.target.value)" [matAutocomplete]="auto">
                  <mat-autocomplete #auto="matAutocomplete">
                    <ng-container *ngFor="let company of attachedToCompanyList">
                      <mat-option [value]="company.name" (click)="attchedToCompanySelected(company)">
                        {{company.name}}
                       
                      </mat-option>
                    </ng-container>
                  </mat-autocomplete>
                </ng-container>

              </div>
            </ng-container>

          <button mat-icon-button *ngIf="show3cCancel==true" class="close3c" (click)="close3c()">
            <mat-icon matTooltip="Cancel">close</mat-icon>
          </button>

          </div>

          <div class="modelAndAI" *ngIf="currentNavigation == 'AI Data'">

            <div class="modelRun">
              <!-- <select [(ngModel)]="modelId" (change)="selectModelAccess($event)">
                <option *ngFor="let stat of modelAccessTypeList" [value]="stat.modelType">
                  {{ stat.name }}
                </option>
              </select> -->
              

             
                <!-- <button class="btn btn-primary runAI" *ngIf="currentNavigation == 'Key Value'"
                (click)="runAI()" [disabled]="systemFeildsList.length==0">Run AI</button> -->
             
            </div>

            <div class="systemAndOther saveField">
              <button color="primary" mat-icon-button class="showPDF"
                (click)="showPDF()"><mat-icon>picture_as_pdf</mat-icon></button>
              <button color="primary" mat-icon-button (click)="openSystemFields()"><mat-icon>add</mat-icon></button>
             
              <button (click)="selectForm(forms)">eSign</button>
                                        
              <button class="btn btn-primary runAI" *ngIf="currentNavigation == 'AI Data'" (click)="runAI()"
              [disabled]="systemFeildsList.length==0">Run AI</button>
              
              <button mat-icon-button color="primary" class="mat-icon-buttton"
                [matMenuTriggerFor]="menu"><mat-icon>more_vert</mat-icon></button>
              <mat-menu #menu="matMenu">

                <button mat-menu-item (click)="SaveAsTemplate(saveTemplates)">
                  <mat-icon>create</mat-icon>Save Field Template
                </button>

                <button mat-menu-item (click)="OpenImportTemplate(importTemplate)">
                  <mat-icon>import_export</mat-icon>Import Field Template
                </button>               

              </mat-menu>

            </div>

          </div>

        </div>

        <div class="codingTable content" *ngIf="currentNavigation == 'AI Data'">

          <div *ngIf="systemFeildsList.length == 0" class="">

            <mat-accordion class="example-headers-align questionblock">
              <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>

                  <table class="headerTable">
                    <tr>
                      <th class="w150">System Field</th>
                      <th class="w150">Form Field</th>
                      <th>Value</th>
                      <th class="action">
                        &nbsp;
                      </th>
                    </tr>
                  </table>

                </mat-expansion-panel-header>
              </mat-expansion-panel>
            </mat-accordion>

          </div>

          <div *ngIf="systemFeildsList.length>0">
            <mat-accordion class="example-headers-align questionblock">
              <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>

                  <table class="headerTable">
                    <tr>
                      <th class="w50"> </th>
                      <th class="w150">System Field</th>
                      <th>Form Field</th>
                      <th>Value</th>
                      <th class="action">
                        &nbsp;
                      </th>
                    </tr>
                  </table>

                </mat-expansion-panel-header>
               <table cdkDropList (cdkDropListDropped)="dropSytemFields($event)">

                  <tr *ngFor="let item of systemFeildsList;let i = index" cdkDrag>                 

                    <td class="w20">
                    <mat-icon cdkDragHandle class="drag-icon" matTooltip="Drag to reorder" matTooltipPosition="above">
                       drag_handle
                    </mat-icon>
                    </td> 

                    <td class="w150"> 
                      <p class="nameOverflow" matTooltipClass="tooltips" matTooltip="{{item.fieldName}}" >{{item.fieldName}}</p>
                    </td>

                    <!-- we have to replace this with autocompelte-->
                    <td class="w150" *ngIf="currentNavigation == 'AI Data'">
                      <div class="inrow alongMapIcon" >
                         <button class="mapIcon" *ngIf="item.colorCode=='#47e309'" mat-icon-button (click)="fieldValueSelectedGotoPage1(item)" >
                          <mat-icon>pin_drop</mat-icon>
                        </button>
                        
                        <input type="text" [ngStyle]="{'color': item.colorCode }" [ngClass]="{'fill': item.value}"
                          (input)="searchAllKeyValueFormFields($event.target.value,item)" [matAutocomplete]="auto1"
                          [(ngModel)]="item.formFieldName" matTooltipClass="tooltips" matTooltip="{{item.formFieldName}}" >
                        <mat-autocomplete #auto1="matAutocomplete" class="autoComplete">
                          <mat-option (click)="formfieldValueSelectedAI(data,item)"
                            *ngFor="let data of allKeyValueDataListFormFeild" [value]="data.key">
                            {{data.key}} , {{data.value}}
                          </mat-option>
                        </mat-autocomplete>

                        <button mat-icon-button (click)="openFormFieldMapping(item)">
                          <mat-icon>linked_services</mat-icon>
                        </button>
                      </div>
                    </td>

                    <!-- we have to replace this with autocompelte-->
                    <td>
                      
                      <input type="text" class="halfValue" [(ngModel)]="item.value" [ngClass]="{'fill': item.value}">
                    </td>


                    <td class="action">
                      <button mat-icon-button class="mat-icon-buttton" (click)="removesystemField(item)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </td>
                  </tr>

                </table>

              </mat-expansion-panel>


            </mat-accordion>

          </div>


        </div>


        <div class="codingTable content" *ngIf="currentNavigation == 'Key Value'">
        
          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>Search</mat-label>
            <input matInput maxlength="20" [(ngModel)]="searchKeyValueData" placeholder="Search key/value"
              (input)="searchKeyValueRecord($event.target.value)">
          </mat-form-field>

          <div *ngIf="allKeyValueDataListFilterForFormFeild.length>0">
            <mat-accordion class="example-headers-align questionblock">
              <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>

                  <table class="headerTable">
                    <tr>
                      <th></th> 
                      <th class="w150">Key</th>                      
                      <th>Value</th>                     
                    </tr>
                  </table>

                </mat-expansion-panel-header>
             
                <table>                
                  
                  <tr *ngFor="let item of allKeyValueDataListFilterForFormFeild;let i = index">
                    <td>
                      <mat-icon style="cursor: pointer;" (click)="fieldValueSelectedGotoPage(item)">pin_drop</mat-icon>   
                    </td>
                    <td class="w150">                       
                                     
                      <p class="nameOverflow" matTooltipClass="tooltips" matTooltip="{{item.key}}" >{{item.key}}</p>
                    </td>                  
                    
                    <td>
                      <p class="nameOverflow" matTooltipClass="tooltips" matTooltip="{{item.value}}" >{{item.value}}</p>
                    </td>
                  
                  </tr>

                </table>
                
                

              </mat-expansion-panel>


            </mat-accordion>

          </div>
          <div *ngIf="allKeyValueDataListFilterForFormFeild.length==0">
            <p class="notFound"> No Record Found</p>
          </div>

        </div>
       

      </div>


      <div class="codingTable content" *ngIf="currentNavigation == 'QUESTIONS'">
       
        <div class="">         

          <div class="AIfilters">
            <h5>Ask Questions to flowtrics AI</h5>           

              <div class="addQuerstion saveField">
                <button (click)="selectForm(forms)">eSign</button>
                <button (click)="openQuestionTemplate(QuestionTemplate)">Save</button>
                <button (click)="OpenImportQuestionTemplate(importQuestionTemplate)">Import</button>
                <button (click)="addQueryBlock(updateQuestion)">Add New</button>
              </div>

          </div>

          <app-ai-question [queryBlocks]="queryBlocks" [sysPromptList]="sysPromptList" [documentsId]="documentId"
            [openAllAccordian]="openAllAccordian" [closeAllAccordian]="closeAllAccordian"
            [VectorDocumentID]="VectorDocumentID" [pdfURL]="pdfURL" [pdfTextFromOCR]="pdfTextFromOCR" [transactionID]="transactionID"
            [documentId]="documentId" [ocrTextFileUrl]="ocrTextFileUrl" (sendDeletedQuery)=getDeletedQuery($event)
            (sendsaveUpdateQuery)=getQueryList($event) (sendPageNumber)=getPageNumber($event)>
          </app-ai-question>
         

        </div>

      </div>


      <div class="codingDetail chooseSystemFeild" *ngIf="showFiledMapping" [ngClass]="{'active': showFiledMapping}">
        
        <div class="heading">
          <h3>Key Value Mapping</h3>
          <button mat-icon-button (click)="showFiledMapping = false"><mat-icon>close</mat-icon></button>
        </div>
        <div class="content">

          
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Search</mat-label>
          <input matInput maxlength="20" [(ngModel)]="searchKeyValueData" placeholder="Search key/value"
            (input)="searchKeyValueRecord($event.target.value)">
        </mat-form-field>

          <div class="filedBlock">
            <table *ngIf="allKeyValueDataListFilterForFormFeild.length>0">
              <tr>
                <th width="40%">Key</th>
                <th width="60%">Value</th>
              </tr>

              <tr *ngFor="let item of allKeyValueDataListFilterForFormFeild;let i = index">


                <td style="cursor: pointer;">
                  <div class="d-flex">
                    <button class="mapIcon" mat-icon-button (click)="fieldValueSelectedGotoPage(item)">
                      <mat-icon>pin_drop</mat-icon>
                    </button>
                    <p (click)="fieldValueSelectedForMapping(item)">{{item.key}}</p>
                  </div>
                </td>

                <td>
                  <p matTooltipClass="tooltips" matTooltip="{{item.value}}">
                    {{item.value}}</p>
                </td>

              </tr>

            </table>

            <div *ngIf="allKeyValueDataListFilterForFormFeild.length==0">
              <p class="notFound"> No Record Found</p>
            </div>

          </div>
        </div>

      </div>

      <div class="codingDetail chooseSystemFeild" *ngIf="showSystemFieldMapping"
        [ngClass]="{'active': showSystemFieldMapping}">

        <div class="heading">
          <h3>Choose System Fields</h3>

          <button class="addBtn" mat-icon-button color="primary" (click)="openAddFields()">
            <mat-icon>add</mat-icon>
          </button>

          <button mat-icon-button (click)="showSystemFieldMapping = false"><mat-icon>close</mat-icon></button>
        </div>

        <!-- Add feild -->
        <div class="addField" *ngIf="showAddField" [ngClass]="{'active': showAddField}">

          <div class="fieldButton">

            <div class="field">
            

              <mat-form-field appearance="outline">
                <mat-label>Field Name</mat-label>
                <mat-chip-list #chipList aria-label="Field selection">
                  <mat-chip *ngFor="let Field of Feilds" [selectable]="selectable" [removable]="removable"
                    (removed)="remove(Field)">
                    {{Field}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip>
                  <input maxlength="50" [(ngModel)]="fieldName" placeholder="Search/Add Field Name"
                    [disabled]="Feilds.length>0" #feildInput [matAutocomplete]="auto"
                    (input)="searchFeildName($event.target.value)" [matChipInputFor]="chipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="add($event)">
                </mat-chip-list>
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                  <mat-option (click)="FeildSelected(obj)" *ngFor="let obj of FieldNameListFiltered"
                    [value]="obj.fieldName">
                    {{obj.fieldName}} ({{obj.fieldTypeName}})
                  </mat-option>
                </mat-autocomplete>

              </mat-form-field>

              <div *ngIf="CreateFeild==true">
                <button mat-flat-button color="primary" [disabled]="ShowAddFieldButton==false"
                  (click)="AddFields()">Add</button>
              </div>
              <div *ngIf="ImportFeild==true">
                <button mat-flat-button color="primary" (click)="ImportFields()">Import</button>
              </div>

            </div>


          </div>
          <p>Field Type: Textbox (You can create textbox type field only from here.)</p>


        </div>
        <!-- Add feild -->

        <div class="content">

          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>Search</mat-label>
            <input matInput maxlength="20" placeholder="search fields"
              (input)="searchSystemFields($event.target.value)">
          </mat-form-field>

          <div *ngIf="systemFieldsAI.length>0">
            <mat-checkbox color="primary" [checked]="checkedAll" (change)="getAllCheckboxValues($event)">
              Select All
            </mat-checkbox>
          </div>


          <div class="filedBlock">
            <h3>System Fields</h3>
            <div class="" *ngIf="systemFieldsAI.length>0">
              <div class="list" *ngFor="let item of systemFieldsAI;let i = index">

                <div class="listblock">
                  <mat-checkbox color="primary" [checked]="item.isChecked" (change)="getCheckboxValues($event, item)">
                    {{item.fieldName}}
                  </mat-checkbox>
                </div>
              </div>
            </div>
           
          </div>

        </div>

        <div class="footerAction">
          <button mat-button (click)="closeAI()">Cancel</button>
          <button mat-flat-button color="primary" [disabled]="ShowAddCustomFeildButton==false"
            (click)="AddSystemFields()">Add</button>

        </div>

      </div>

      <div class="codingTable content" *ngIf="currentNavigation == 'AI Chat'">
        

       
          <div class="all_aiChat">
            
            <div class="chat_container">
              <ng-container *ngFor="let chatHistory of aiChatHistoryArray; let i = index">
               

                <div class="message">

                  <div class="user">
                    YU
                  </div>
            
                  <div class="infoMessage">
                      <p class="label" >You
                        <!-- <span>15 min</span> -->
                      </p>
                      <p>{{chatHistory.aiQuestion}}</p>
                  </div>
            
                </div>

               

                <div class="message airesponse">
                  <div class="user">
                    <img src="../../../assets/images/logo/MiniLogo.png" >
                  </div>
                  <div class="infoMessage">
                   
                      <p class="label">Flowtrics AI 
                        <span> 
                          <button color="primary"  *ngIf="!chatHistory.ChatHistoryID" mat-flat-button class="save-btn" style="top: 0; right: 0;" (click)="SaveAIChatHistory(chatHistory)">
                          Save
                        </button></span>
                      </p>
                      <p [innerHTML]="chatHistory.aiAnswer"></p> 
                  </div>
                </div>

              

              
         
             </ng-container>
          </div>



        <mat-card class="postMessage">
          <div class="post">
              <textarea placeholder="Type your message" (keyup.enter)="query_vector_AIChat()" [(ngModel)]="AIChatQuery"></textarea>
          </div>
          <button (click)="query_vector_AIChat()" mat-icon-button color="primary">
              <mat-icon>send</mat-icon>
          </button>
      </mat-card>
          </div>


      </div>


      <div class="saveHolder" *ngIf="currentNavigation == 'AI Data'">
        <button mat-flat-button class="saveBtn" color="primary"
                      (click)="addMappedKeyValueDatas($event)"
                     [disabled]="systemFeildsList.length==0">
                     Save
        </button>
      </div>

    </div>

    <button (click)="closeDetail(false)" color="primary" mat-icon-button class="closeAiDetail inMobile">
      <mat-icon>close</mat-icon>
    </button>

  </div>


</mat-card>


<ng-template #saveTemplates>

  <form [formGroup]="addTemplateForm">
    <h2 mat-dialog-title>
      <span class="groupIcon"><mat-icon>create_new_folder</mat-icon></span>
      Save Field Template
      <button mat-icon-button (click)="closeSaveAsTemplate()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content>
      <mat-radio-group color="primary" aria-label="Select an option">
        <mat-radio-button value="0" (change)="OnCategoryChangeFieldTemp(0)" [checked]="true" style="margin-right: 15px;">My Templates</mat-radio-button>
        <mat-radio-button value="2" *ngIf="isOfficeAdmin || isOrganizationAdmin" (change)="OnCategoryChangeFieldTemp(2)" style="margin-right: 15px;">Save as Organization Template</mat-radio-button>
        <mat-radio-button value="1" *ngIf="isSuperAdmin" (change)="OnCategoryChangeFieldTemp(1)" [checked]="categoryType==1">Save Global Template Only
        </mat-radio-button>
      </mat-radio-group>

      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" (selectedTabChange)="getTabDetailFieldTemplate($event)">
        <mat-tab label="New">

          <div class="tabContainer">
            <div class="d-flex">

              <mat-form-field appearance="fill">
                <mat-label>Select Category</mat-label>
                <mat-select formControlName="folderID">
                  <mat-option *ngFor="let stat of filteredTempCategoryList" [value]="stat.ocrTemplateCategoryID">
                    {{ stat.ocrTemplateCategoryName }}
                  </mat-option>
                </mat-select>

              </mat-form-field>

              <button class="addBtn" mat-icon-button color="primary" (click)="openDialogAddWithRef()">
                <mat-icon>add</mat-icon> </button>

            </div>
            <mat-form-field class="">
              <mat-label>Template Name</mat-label>
              <input matInput formControlName="taskTemplateName" maxlength="100" placeholder="add template name" />
            </mat-form-field>
          </div>
        </mat-tab>

       <mat-tab label="Update Existing">
          <div class="tabContainer">

          <div class="template-holder">
             <div class="left">

         <mat-form-field appearance="fill">
        <mat-label>Select Category</mat-label>
        <mat-select (selectionChange)="OnSelectCategoryImportFieldTemp($event)" value="My Template">
          <mat-option value="My Template">Template</mat-option>
          <mat-option value="Organization">Organization</mat-option>
          <mat-option value="Global">Global</mat-option>
        </mat-select>
        
      </mat-form-field>

      <div class="list" #categoryList>
        <ul>
          <li (click)="getTaskListThroughCategoryForImport(0, 0)" [ngClass]="{'active': currentIndex == 0 }">All
          </li>
          <ng-container *ngFor="let stat of filteredTempCategoryList; let i = index">
            <li (click)="getTaskListThroughCategoryForImport(stat.ocrTemplateCategoryID, i+1)"
              [ngClass]="{'active': currentIndex == i+1 }"> {{ stat.ocrTemplateCategoryName }}</li>
          </ng-container>
        </ul>

      </div>

    </div>
    <div class="right">

      <div class="list">

        <div class="tempalteList">
          <table cellspacing="0" cellspadding="0" width="100%">
            <tr>
              <th>Template Name</th>
              <th class="actBtn">Action</th>
            </tr>
            <tr *ngFor="let template of  ImportTemplatesList"
              [ngClass]="{ 'active': template.templateID === TemplateIDImportTask}">

              <td class="formName">
                {{template.tempalteName}}
              </td>

              <td>
                <button mat-stroked-button color="primary" (click)="SelectFieldTemplate(template)">Select</button>
              </td>
            </tr>
          </table>
          <div *ngIf="ShowNoRecordFoundTemplates" class="noRecordFound">No Record Found</div>
        </div>

      </div>

    </div>
           </div>
          </div>

        </mat-tab>
      </mat-tab-group>

    </mat-dialog-content>

    <mat-dialog-actions *ngIf="showNewSaveFieldTemplate"  align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button color="basic" (click)="closeSaveAsTemplate()">Cancel</button>
      <button mat-flat-button class="calltoaction" type="submit" color="primary"
        [disabled]="addTemplateForm.invalid || !addTemplateForm.dirty" (click)="AddTemplate(addTemplateForm.value)">
        Add
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>

     <mat-dialog-actions *ngIf="ShowExistingSaveFieldTemplate"  align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button color="basic" (click)="closeSaveAsTemplate()">Cancel</button>
      <button mat-flat-button class="calltoaction" type="submit" color="primary"
        [disabled]="updateSelectedField==false" (click)="UpdateFieldTemplate()">
        Update
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>

  </form>

</ng-template>

<ng-template #importTemplate>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
    Import Field Template
    <button mat-icon-button (click)="closeImportTaskTemplate()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>


  <div class="template-holder">
    <div class="left">

      <mat-form-field appearance="fill">
        <mat-label>Select Category</mat-label>
        <mat-select (selectionChange)="OnSelectCategoryImportFieldTemp($event)" value="My Template">
          <mat-option value="My Template">Template</mat-option>
          <mat-option value="Organization">Organization</mat-option>
          <mat-option value="Global">Global</mat-option>
        </mat-select>
        
      </mat-form-field>

      <div class="list" #categoryList>
        <ul>
          <li (click)="getTaskListThroughCategoryForImport(0, 0)" [ngClass]="{'active': currentIndex == 0 }">All
          </li>
          <ng-container *ngFor="let stat of filteredTempCategoryList; let i = index">
            <li (click)="getTaskListThroughCategoryForImport(stat.ocrTemplateCategoryID, i+1)"
              [ngClass]="{'active': currentIndex == i+1 }"> {{ stat.ocrTemplateCategoryName }}</li>
          </ng-container>
        </ul>

      </div>

    </div>
    <div class="right">

      <div class="list">

        <div class="tempalteList">
          <table cellspacing="0" cellspadding="0" width="100%">
            <tr>
              <th>Template Name</th>
              <th class="actBtn">Action</th>
            </tr>
            <tr *ngFor="let template of  ImportTemplatesList"
              [ngClass]="{ 'active': template.templateID === TemplateIDImportTask}">

              <td class="formName">
                {{template.tempalteName}}
              </td>

              <td>
                <button mat-stroked-button color="primary" (click)="SelectTemplate(template)">Select</button>
              </td>
            </tr>
          </table>
          <div *ngIf="ShowNoRecordFoundTemplates" class="noRecordFound">No Record Found</div>
        </div>

      </div>

    </div>
  </div>

  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="closeImportTaskTemplate()">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" color="primary" *ngIf="TemplateIDImportTask!=0"
      (click)="importTemplates()">
      Import
    </button>
  </mat-dialog-actions>


</ng-template>



<ng-template #saveAsTemplateDialog>
  <form [formGroup]="addTemplateForm">
    <h2 mat-dialog-title>
      <span class="groupIcon"><mat-icon>create_new_folder</mat-icon></span>
      Save Template
      <button mat-icon-button (click)="closeSaveAsTemplate()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content>
      <mat-radio-group color="primary" aria-label="Select an option">
        <mat-radio-button value="0" [checked]="true" style="margin-right: 15px;">Templates</mat-radio-button>
        <!-- <mat-radio-button value="2" *ngIf="isOrganizationAdmin" (change)="OnCategoryChange(2)" [checked]="categoryType==2"
          style="margin-right: 15px;">Save as Organization
          Template</mat-radio-button>
        <mat-radio-button value="1" *ngIf="isSuperAdmin" (change)="OnCategoryChange(1)" [checked]="categoryType==1">Save
          Global Template Only</mat-radio-button> -->
      </mat-radio-group>

      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
        <mat-tab>

          <div class="tabContainer">
            <div class="d-flex">

              <mat-form-field appearance="fill">
                <mat-label>Select Category</mat-label>
                <mat-select formControlName="folderID">
                  <mat-option *ngFor="let stat of filteredTempCategoryList" [value]="stat.ocrTemplateCategoryID">
                    {{ stat.ocrTemplateCategoryName }}
                  </mat-option>
                </mat-select>

              </mat-form-field>

              <button class="addBtn" mat-icon-button color="primary" (click)="openDialogAddWithRef()">
                <mat-icon>add</mat-icon> </button>

            </div>
            <mat-form-field class="">
              <mat-label>Template Name</mat-label>
              <input matInput formControlName="taskTemplateName" maxlength="100" placeholder="add template name" />
            </mat-form-field>
          </div>
        </mat-tab>
      </mat-tab-group>

    </mat-dialog-content>

    <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button color="basic" (click)="closeSaveAsTemplate()">Cancel</button>
      <button mat-flat-button class="calltoaction" type="submit" color="primary"
        [disabled]="addTemplateForm.invalid || !addTemplateForm.dirty" (click)="AddTemplate(addTemplateForm.value)">
        Add
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>
  </form>
</ng-template>



<ng-template #QuestionTemplate>
  <form [formGroup]="addTemplateForm">
    <h2 mat-dialog-title>
      <span class="groupIcon"><mat-icon>create_new_folder</mat-icon></span>
      Save/Update Question Template
      <button mat-icon-button (click)="closeSaveAsTemplateForQuestionTemplate()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content>
      <mat-radio-group color="primary" aria-label="Select an option">
        <mat-radio-button value="0" (change)="OnCategoryChange(0)" [checked]="true" style="margin-right: 15px;">
          My Templates
        </mat-radio-button>
        <mat-radio-button value="2" *ngIf="isOfficeAdmin || isOrganizationAdmin" (change)="OnCategoryChange(2)"
          style="margin-right: 15px;">Save as Organization Template
        </mat-radio-button>
        <mat-radio-button value="1" *ngIf="isSuperAdmin" (change)="OnCategoryChange(1)">
          Save Global Template Only
        </mat-radio-button>
      </mat-radio-group>

      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start"
        (selectedTabChange)="getTabDetailsQuestionTemplate($event)">
        <mat-tab label="New">

          <div class="tabContainer">
            <div class="d-flex">

              <mat-form-field appearance="fill">
                <mat-label>Select Category</mat-label>
                <mat-select formControlName="folderID">
                  <mat-option *ngFor="let stat of filteredQuestionCategoryList" [value]="stat.nlpTemplateCategoryID">
                    {{ stat.nlpTemplateCategoryName }}
                  </mat-option>
                </mat-select>

              </mat-form-field>

              <button class="addBtn" mat-icon-button color="primary" (click)="openDialogAddQuestionTemplate()">
                <mat-icon>add</mat-icon> </button>
            </div>
            <mat-form-field class="">
              <mat-label>Template Name</mat-label>
              <input matInput formControlName="taskTemplateName" maxlength="100" placeholder="Add Template Name" />
            </mat-form-field>
          </div>
        </mat-tab>

        <mat-tab label="Update Existing">
          <div class="tabContainer">

            <div class="searchSelectCat">
              <div class="selectCat">
                <mat-form-field class="example-full-width" appearance="fill">
                  <mat-label>Select Category</mat-label>
                  <mat-select [(value)]="selectedCategory" (selectionChange)="getSelectQuestionTemplate($event)">
                    <mat-option [value]="0">All</mat-option>
                    <mat-option *ngFor="let stat of filteredQuestionCategoryList" [value]="stat.nlpTemplateCategoryID">
                      {{ stat.nlpTemplateCategoryName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>


              <div class="search">
                <mat-form-field class="example-full-width" appearance="fill">
                  <mat-label>Search</mat-label>
                  <input matInput maxlength="20" [(ngModel)]="searchTemplateQuestion" placeholder="Search Template"
                    (input)="searchTemplateForQuestion($event.target.value)">
                </mat-form-field>
              </div>
            </div>


            <div class="tempalteList">
              <table cellspacing="0" cellspadding="0" *ngIf="!ShowNoRecordFoundQuestionTemplate">
                <tr>
                  <th class="formName">Template Name</th>
                  <th class="actBtn">Action</th>
                </tr>
                <tr *ngFor="let template of NLPTemplatesList"
                  [ngClass]="{ 'active': template.templateID === nlpTemplateID}">

                  <td class="formName">
                    {{template.tempalteName}}
                  </td>

                  <td class="actBtn">
                    <button mat-icon-button color="primary" mat-icon-button matTooltipClass="tooltip"
                      matTooltip="Select"
                      (click)="SelectTemplateForQuestionTemplate(template)"><mat-icon>post_add</mat-icon>
                    </button>
                  </td>
                </tr>
              </table>
              <div *ngIf="ShowNoRecordFoundQuestionTemplate" class="noRecordFound">No Records Found</div>
            </div>
          </div>

        </mat-tab>
      </mat-tab-group>

    </mat-dialog-content>

    <mat-dialog-actions *ngIf="showNew" align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button color="basic" (click)="closeSaveAsTemplateForQuestionTemplate()">Cancel</button>
      <button mat-flat-button class="calltoaction" type="submit" color="primary"
        [disabled]="addTemplateForm.invalid || !addTemplateForm.dirty"
        (click)="AddQuestionTemplate(addTemplateForm.value)">
        Add
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>

    <mat-dialog-actions *ngIf="showExisting" align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button color="basic" (click)="closeSaveAsTemplateForQuestionTemplate()">Cancel</button>
      <button mat-flat-button class="calltoaction" type="submit" color="primary"
        [disabled]="!updateQuestionTemplateButton" (click)="updateNLPTemplateData()">
        Update
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>

  </form>
</ng-template>


<ng-template #importQuestionTemplate>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
    Import Question Template
    <button mat-icon-button (click)="closeImportTaskTemplate()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>


  <div class="template-holder">
    <div class="left">

      <mat-form-field appearance="fill">
        <mat-label>Select Category</mat-label>
        <mat-select (selectionChange)="OnSelectCategoryImportTemp($event)" value="My Template">
          <mat-option value="My Template">Template</mat-option>
          <mat-option value="Organization">Organization</mat-option>
          <mat-option value="Global">Global</mat-option>
        </mat-select>
      </mat-form-field>

      <div class="list" #categoryList>
        <ul>
          <li (click)="getThroughCategoryForQuestionTempImport(0, 0)" [ngClass]="{'active': currentIndex == 0 }">
            All
          </li>
          <ng-container *ngFor="let stat of filteredQuestionCategoryList; let i = index">
            <li (click)="getThroughCategoryForQuestionTempImport(stat.nlpTemplateCategoryID, i+1)"
              [ngClass]="{'active': currentIndex == i+1 }"> {{ stat.nlpTemplateCategoryName }}</li>
          </ng-container>
        </ul>

      </div>

    </div>
    <div class="right">

      <div class="list">

        <div class="tempalteList">
          <table cellspacing="0" cellspadding="0" width="100%">
            <tr>
              <th>Template Name</th>
              <th class="actBtn">Action</th>
            </tr>
            <tr *ngFor="let template of NLPTemplatesList"
              [ngClass]="{ 'active': template.templateID === QuestionTemplateIDImportTask}"
              [ngStyle]="{ 'background-color': template.templateID === QuestionTemplateIDImportTask ? '#e8f0fe' : 'transparent' }">

              <td class="formName">
                {{template.tempalteName}}
              </td>

              <td>
                <button mat-stroked-button color="primary"
                  (click)="SelectTemplateQuestionTempForImport(template)">Select</button>
              </td>
            </tr>
          </table>
          <div *ngIf="ShowNoRecordFoundQuestionTemplate" class="noRecordFound">No Record Found</div>
        </div>

      </div>

    </div>
  </div>

  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="closeImportQuestionTemplate()">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" color="primary" *ngIf="QuestionTemplateIDImportTask!=0"
      (click)="importQuestionTemplates()">
      Import
    </button>
  </mat-dialog-actions>


</ng-template>


<ng-template #mergePDFs>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
    Merge PDF into Selected Document
    <button mat-icon-button (click)="closeMergPDF()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
 
  <div>

    <input #Input hidden="true" type="file" multiple (change)="selectFilesFromDragZone($event)">
    <button class="upload_file_btn" mat-menu-item (click)="Input.click()">
      <mat-icon>upload_file</mat-icon> Upload File
    </button>

    <div cdkDropList class="fileHolder" (cdkDropListDropped)="drop($event)">
      <div class="example-box" *ngFor="let file of UploadedFiles; let i = index" cdkDrag>
        <ng-container>

          <div class="example-custom-placeholder" *cdkDragPlaceholder></div>

          <mat-card class="fileCont">
            <div class="DragIcon" cdkDragHandle>
              <mat-icon>drag_indicator</mat-icon>
            </div>

            <div class="Icon" *ngIf="file.documentType == 'pdf' || file.documentType == '.pdf' || file.documentType == 'PDF'">            
              <app-doc-icons  [iconType]="'PDF'"></app-doc-icons>
            </div>

            <!-- <div class="Icon"
              *ngIf="file.documentType == 'pdf' || file.documentType == '.pdf' || file.documentType == 'PDF'">
              <img src="../../../../assets/icons/fileType/pdf_icon.svg" alt="Pdf File" />
            </div> -->

            <div class="nameInfo">
              <h2>{{ file.fileName }}</h2>
              <p>{{ file.Totalsize }}</p>
              <p *ngIf="file.pageCount">Pages: {{ file.pageCount }}</p>
            </div>

            <div class="docAct">
              <button (click)="deleteFileFromUploaded(file,i)" mat-icon-button color="basic" matTooltipClass="tooltip"
                matTooltip="Delete">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>

          </mat-card>

        </ng-container>
      </div>
    </div>


    <div class="newDoc">
      <mat-slide-toggle *ngIf="UploadedFiles.length>0" color="primary" (change)="isNewToggle($event)">
        Save as a new document
      </mat-slide-toggle>


      Total Pages: {{totalPDFPages}}

    </div>

    <mat-form-field class="m10" *ngIf="IsNew==true">
      <mat-label>Document Name</mat-label>
      <input matInput maxlength="100" placeholder="add document name" [(ngModel)]="documentNames" />
    </mat-form-field>


  </div>

  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">

    <div *ngIf="totalPDFPages>200" style="color: red;">
      We recommend limiting the merged document to 200 pages to prevent potential feature malfunctions.
    </div>

    <button mat-button color="basic" (click)="closeMergPDF()">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" color="primary" *ngIf="UploadedFiles.length>0"
      (click)="mergePdf()">
      Merge
    </button>
  </mat-dialog-actions>

  <br>
  <br>
  <div *ngIf="MergedFileHistoryList.length>0">
    <p>Uploaded File History</p>
   
    <div class="alldocs">
      <div class="example-box " *ngFor="let file of MergedFileHistoryList; let i = index">
      
        <ng-container>
         
          <mat-card class="fileConts">         
  
            <div class="Icon" *ngIf="file.fileType == 'pdf' || file.fileType == '.pdf' || file.fileType == 'PDF'">            
              <app-doc-icons  [iconType]="'PDF'"></app-doc-icons>
            </div>
           
            <div class="nameInfo">
              <h2>{{ file.name }}</h2>
              <p>{{ file.fileSize }}</p>           
            </div>
           
          </mat-card>
  
        </ng-container>
      </div>
    
    </div>    
  </div>

</ng-template>


<app-addnew *ngIf="showAddCore" (closeAdd)="getClose($event)" [name]="searchName" [isShared]="isShare"
  [mainModuleName]='mainModuleName' [modulename]='Module' [ngClass]="{'open': showAddCore}" [aiDetails]="systemFeildsList"
  (selectedCoreIdForAI)=getselectedTransactionId($event)>
</app-addnew>


 <app-details *ngIf="showDetail"  [ngClass]="{ open: showDetail }" [transactionID]='transactionID'
 [modulenames]='mainModuleNameForDetails' [modulename]="getTooltipText()" (closeDetail)="getCloseDetails($event)"
 [aiDetails]="systemFeildsList" [ViewOrUpdate]="vieworUpdate">
</app-details>


<ng-template #updateQuestion>
  <form [formGroup]="formDialog">
    <h2 mat-dialog-title>
      <span class="groupIcon">
        <mat-icon>view_column</mat-icon>
      </span>
      Add Question

      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>

    </h2>

    <mat-dialog-content class="mat-typography">

      <div class="aiAdd">

        <div class="left">
        
          <mat-form-field class="example-half-width">
            <mat-label>Title</mat-label>
            <input matInput placeholder="Add Title" formControlName="title">
          </mat-form-field>

          <mat-expansion-panel [expanded]="true" disabled="false" class="questionTitle">
            <mat-expansion-panel-header>
              <mat-panel-title>Use Response from Prior Questions</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="d-flex">

              <div *ngFor="let block of queryBlocks; let i = index" class="mr-10">

                <div class="checkbox-container">
                  <mat-checkbox (change)="OnChangeChooseAnswer($event,block,i)">
                    {{block.title}}
                  </mat-checkbox>
                </div>
              </div>
            </div>


          </mat-expansion-panel>

          <div class="checkbox-container">
            <mat-checkbox formControlName="isNta" style="float: right;">
              Use NTA
            </mat-checkbox>
            <mat-checkbox formControlName="isMedication" style="float: right; margin-right: 15px;">
              Use Medication
            </mat-checkbox>
          </div>
        </div>

        <div *ngIf="ddlsystemPromptID!=undefined && sysPromptList?.length > 0">
          <mat-form-field class="example-half-width">
            <mat-label>Predefined Models</mat-label>
            <mat-select [(value)]="ddlsystemPromptID" (selectionChange)="selectSysPrompt($event)">
              <mat-option value="0">-Select Predefined Models-</mat-option>
              <mat-option *ngFor="let type of sysPromptList; trackBy: trackByFn" [value]="type.systemPromptID">
                {{ type.systemPromptTitle }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        
        <div class="right">
          <mat-form-field class="example-half-width">
            <mat-label>Question</mat-label>
            <textarea matInput placeholder="Type your question here if you are not using predefined model above" rows="10" cols="40" formControlName="prompt">
         </textarea>
          </mat-form-field>
        </div>

      </div>

    </mat-dialog-content>

    <mat-dialog-actions>
      <button mat-button (click)="close()">Cancel</button>
      <div class="">
        <!-- <button mat-stroked-button color="primary" (click)="SendDocumentTo_4o_DBDialogue(formDialog.value)">Run AI</button> -->
        <button mat-flat-button color="primary" [disabled]="formDialog.invalid || !formDialog.dirty"
          (click)="addQuestions(formDialog.value)">
          Add
        </button>
      </div>
    </mat-dialog-actions>

    <!-- <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-stroked-button color="primary" (click)="runAIButton(formDialog.value)">Run AI</button>
    <button mat-flat-button color="primary"  [disabled]="formDialog.invalid || !formDialog.dirty"   
      (click)="addQuestion(formDialog.value)">
      Add
    </button>
  </mat-dialog-actions> -->
  </form>
</ng-template>


<ng-template #forms>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>note_add</mat-icon>
    </span>
    My Forms
    <button mat-icon-button (click)="closeFormImports()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>


    <div class="myforms">
      <div class="drive mainLink">
        <div class="folderName" (click)="GetAllForms()">
          <mat-icon class="type">account_balance</mat-icon>
          Forms
        </div>

        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
          <mat-tree-node [ngClass]="{ 'active': activeNode === node.formFolderID }" *matTreeNodeDef="let node"
            matTreeNodePadding matTreeNodePaddingIndent="20">
            <div class="folderRow">
              <mat-icon class="mat-icon-rtl-mirror arrowIcon" style="visibility: hidden;">
                arrow_right
              </mat-icon>

              <div class="folderName">
                <mat-icon class="folder" *ngIf="node.isShared == false"
                  (click)="getFormFolderWithTemplatesLeftPanel(node)">folder</mat-icon>
                <mat-icon class="folder" *ngIf="node.isShared == true"
                  (click)="getFormFolderWithTemplatesLeftPanel(node)">folder_shared</mat-icon>
                <span class="flname" (click)="getFormFolderWithTemplatesLeftPanel(node)">{{node.formFolderName}}</span>
              </div>
            </div>
          </mat-tree-node>

          <mat-tree-node [ngClass]="{ 'active': activeNode === node.formFolderID }"
            *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding matTreeNodePaddingIndent="20">
            <div class="folderRow" matTreeNodeToggle [attr.aria-label]="'toggle ' + node.formFolderName">
              <mat-icon class="mat-icon-rtl-mirror arrowIcon">
                {{treeControl.isExpanded(node) ? 'arrow_drop_down' : 'arrow_right'}}
              </mat-icon>
              <div class="folderName">
                <mat-icon class="folder" *ngIf="node.isShared == false"
                  (click)="getFormFolderWithTemplatesLeftPanel(node)">folder</mat-icon>
                <mat-icon class="folder" *ngIf="node.isShared == true"
                  (click)="getFormFolderWithTemplatesLeftPanel(node)">folder_shared</mat-icon>
                <span class="flname" (click)="getFormFolderWithTemplatesLeftPanel(node)">{{node.formFolderName}}</span>
              </div>
            </div>

          </mat-tree-node>
        </mat-tree>

        <div class="folderName" (click)="getSharedWithMe()" [ngClass]="{ 'active': SharedWithMeactive }">
          <mat-icon class="type">portrait</mat-icon> Shared with me
        </div>

      </div>

      <div class="driveDetail" *ngIf="isShowForm">

        <div class="breadcumb">
          <span (click)="breadCrumbMainClick()">Forms</span>
          <span *ngFor="let m of menuHeader;let i= index;">
            <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
            <a (click)="breadCrumb(menuHeader, i)">{{ m.label }}</a>
          </span>
        </div>

        <mat-card class="files">
          <table class="mat-table">
            <thead>
              <tr class="mat-header-row">
                <th class="mat-header-cell wstar">&nbsp; </th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell">Name</th>
                <th class="mat-header-cell date">Created On</th>
                <th class="mat-header-cell date">Modified On</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let form of FormFolderListMiddleSection; let i = index;">
                <tr class="mat-row foldericon" (click)="radioChange(form,'MyForm')">
                  <td class="mat-cell wstar">
                    <span class="checkbo" *ngIf="form.type == 2">
                      <mat-radio-button color="primary" value="i" [checked]="form.isChecked"
                        (change)="radioChange(form,'MyForm')"></mat-radio-button>
                    </span>
                  </td>

                  <ng-container *ngIf="getIsFavorite(form) == true; else showFavorite">
                    <td class="mat-cell">
                      <mat-icon class="fav">grade</mat-icon>
                    </td>
                  </ng-container>

                  <ng-template #showFavorite>
                    <td class="mat-cell">
                      <mat-icon class="star">grade</mat-icon>
                    </td>
                  </ng-template>

                  <td class="mat-cell docType" *ngIf="form.type == 1 && form.isShared == false">
                    <mat-icon>folder</mat-icon>
                  </td>

                  <td class="mat-cell docType" *ngIf="form.type == 1 && form.isShared == true">
                    <mat-icon>folder_shared</mat-icon>
                  </td>

                  <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==1">
                    <img src="../../../../assets/images/icons/formIcon.svg" alt="" width="28" />
                    <!-- <mat-icon>description</mat-icon> -->
                  </td>

                  <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==2">
                    <img src="../../../../assets/images/icons/form_tabuler.svg" alt="" width="28" />
                    <!-- <mat-icon>table_rows</mat-icon> -->
                  </td>

                  <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==3">
                    <img src="../../../../assets/images/icons/form_html.svg" alt="" width="28" />
                    <!-- <mat-icon>table_rows</mat-icon> -->
                  </td>

                  <td class="mat-cell" *ngIf="form.type == 1">
                    <span class="formName" matTooltipClass="tooltip" matTooltip="{{form.name}}">{{ form.name }}</span>
                  </td>

                  <td class="mat-cell" *ngIf="form.type == 2">
                    <span class="formName" matTooltipClass="tooltip" matTooltip="{{form.name}}">{{ form.name }}</span>
                  </td>

                  <td class="mat-cell">
                    {{ form.createdOn +'Z'| date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.updatedOn!=null">
                    {{ form.updatedOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.updatedOn==null">
                    {{ form.createdOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>


                </tr>
              </ng-container>

              <ng-container *ngIf="!FormFolderListMiddleSection">
                <tr>
                  <td colspan="7">
                    <p class="nocontent">No Items Found</p>
                  </td>
                </tr>
              </ng-container>

            </tbody>
          </table>
        </mat-card>
      </div>

      <div class="driveDetail" *ngIf="isSharedWithMe">

        <div class="breadcumb">
          <span (click)="breadCrumbMainSHaredWithMeClick()">Shared with me</span>
          <span *ngFor="let m of menuHeader;let i= index;">
            <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
            <a (click)="breadCrumb(menuHeader, i)">{{ m.label }}</a>
          </span>
        </div>

        <mat-card class="files">
          <table class="mat-table">
            <thead>
              <tr class="mat-header-row">
                <th class="mat-header-cell wstar">&nbsp; </th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell">Name</th>
                <th class="mat-header-cell" *ngIf="parentID==0">Shared By</th>
                <th class="mat-header-cell date">Created On</th>
                <th class="mat-header-cell date">Modified On</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let form of SharedWithMeFormFolderList; let i = index;">
                <tr class="mat-row foldericon" (click)="radioChange(form,'SharedWithMe')">
                  <td class="mat-cell wstar">
                    <span class="checkbo" *ngIf="form.type == 2">
                      <mat-radio-button color="primary" value="i" [checked]="form.isChecked"
                        (change)="radioChange(form,'SharedWithMe')"></mat-radio-button>
                    </span>
                  </td>

                  <ng-container *ngIf="getIsFavorite(form) == true; else showFavorite">
                    <td class="mat-cell">
                      <mat-icon class="fav">grade</mat-icon>
                    </td>
                  </ng-container>

                  <ng-template #showFavorite>
                    <td class="mat-cell">
                      <mat-icon class="star">grade</mat-icon>
                    </td>
                  </ng-template>

                  <td class="mat-cell docType" *ngIf="form.type == 1">
                    <mat-icon>folder</mat-icon>
                  </td>

                  <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==1">
                    <img src="../../../../assets/images/icons/formIcon.svg" alt="" width="28" />
                    <!-- <mat-icon>description</mat-icon> -->
                  </td>

                  <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==2">
                    <!-- <mat-icon>table_rows</mat-icon> -->
                    <img src="../../../../assets/images/icons/form_tabuler.svg" alt="" width="28" />
                  </td>

                  <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==3">
                    <!-- <mat-icon>table_rows</mat-icon> -->
                    <img src="../../../../assets/images/icons/form_html.svg" alt="" width="28" />
                  </td>

                  <td class="mat-cell" (click)="getFormFolderWithFormTemplatesSharedWithMe(form)"
                    *ngIf="form.type == 1">
                    <span class="formName" matTooltipClass="tooltip" matTooltip="{{form.name}}">{{ form.name }}</span>
                  </td>

                  <td class="mat-cell" *ngIf="form.type == 2">
                    <span class="formName" matTooltipClass="tooltip" matTooltip="{{form.name}}">{{ form.name }}</span>
                  </td>

                  <td class="mat-cell" *ngIf="parentID==0">
                    <span class="formName" matTooltipClass="tooltip">
                      {{ form.sharedbyFirstName }} {{ form.sharedbyLastName }}
                    </span>
                  </td>

                  <td class="mat-cell" (click)="getFormFolderWithFormTemplatesSharedWithMe(form)"
                    *ngIf="form.type == 1">
                    {{ form.createdOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.type == 2">
                    {{ form.createdOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" (click)="getFormFolderWithFormTemplatesSharedWithMe(form)"
                    *ngIf="form.type == 1">
                    {{ form.updatedOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.type == 2">
                    {{ form.updatedOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                </tr>
              </ng-container>

              <ng-container *ngIf="SharedWithMeFormFolderList.length==0">
                <tr>
                  <td colspan="7">
                    <p class="nocontent">No Items Found</p>
                  </td>
                </tr>
              </ng-container>

            </tbody>
          </table>
        </mat-card>
      </div>

    </div>


  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-stroked-button color="basic" (click)="closeFormImports()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!selectButtonShow" (click)="SelectFormSubmit()">Select</button>
  </mat-dialog-actions>
</ng-template>


<ng-template #docViewer>
  <app-document-viewers
  (getCloseDocumentViewer)="getCloseDocumentViewer($event)"
  [ngClass]="{ open: documentViewers }"
  [documentpath]="documentPath"
  [documentType]="fileType"
  [documentName]="documentname">
  </app-document-viewers>
  </ng-template>

<app-loader></app-loader>